define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var businessPlanAdminRoles = ['Business Plan Administrator'];
	var businessPlanLibAdminRoles = ['Business Plan Library Administrator'];

	csiAccess.addViewRoles({
		"_CS_Data":{
			"Currency": {
				"NewCurrency":access( full(businessPlanLibAdminRoles))
			},
			"CurrencyTables": {
				"NewCurrencyExchangeTable":access( full(businessPlanLibAdminRoles)),
				"Copy":access( full(businessPlanLibAdminRoles)),
				"EditExchangeRates":access( full(businessPlanLibAdminRoles), full(businessPlanAdminRoles))
			}
		},
		"_CS_BusinessPlanningViews":{
			"BusinessPlans": {
				"NewBusinessPlan":access( full(businessPlanAdminRoles)),
				"Copy":access( full(businessPlanAdminRoles))
			},
			"BusinessCategories": {
				"NewBusinessCategory":access( full(businessPlanLibAdminRoles)),
				"Copy":access( full(businessPlanLibAdminRoles))
			},
			"BusinessMarkets": {
				"NewBusinessMarket":access( full(businessPlanLibAdminRoles)),
				"Copy":access( full(businessPlanLibAdminRoles))
			}
		}
	});
});